var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('enum-picker',{attrs:{"rules":_vm.rules,"place-holder":'Dilekçe Tipi Seçiniz',"enum":_vm.dilekceTipi,"labels":_vm.dilekceTipiLabel,"label":_vm.label,"hide-details":""},on:{"input":_vm.input},model:{value:(_vm.localValue),callback:function ($$v) {_vm.localValue=$$v},expression:"localValue"}})
}
var staticRenderFns = []

export { render, staticRenderFns }